import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose"; // @flow

import React from 'react';
import DefaultTheme from './theme';
export var ListTheme = DefaultTheme;
/*::
import type { Node } from 'react';
import type { ListThemeType } from './theme';

export type Props = {|
  theme?: ListThemeType,
  children?: Node,
  rest?: any,
|}
*/

var List = function List(_ref
/*: Props */
) {
  var _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? DefaultTheme : _ref$theme,
      children = _ref.children,
      rest = _objectWithoutPropertiesLoose(_ref, ["theme", "children"]);

  return /*#__PURE__*/React.createElement(theme.Main, rest, React.Children.map(children, function (item, idx) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      React.createElement(theme.ItemWrapper, {
        key: idx
      }, item)
    );
  }));
};

export default List;